import { CommonController } from './CommonController';
import { FaqAccordion } from '~/modules/Accordion';
import { OtherSlider } from '../modules/Slider';

export class SubpageController extends CommonController {
  onInit() {
    super.onInit();
  }
  onLoad() {
    super.onLoad();
    
    new FaqAccordion();
    new OtherSlider();
  }
  onDestroy() {
    super.onDestroy();
  }
}
